require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-piringsdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-piringsdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-piringsdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-piringsdorf.json
// module id = 990
// module chunks = 231608221292675